var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"sticky-footer"}},[_c('div',{staticClass:"w-100 text-center"},[_c('span',[_vm._v("Copyright © 2020 Xeno-Data GmbH")])])])
}]

export { render, staticRenderFns }